import React, { useState } from "react";
import { createPortal } from "react-dom";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../../../auth/AuthProvider";
import { firestore } from "../../../helpers/firebaseConfig";
import { trackBuilderEvent, trackBuilderFailure } from "../../../helpers/builderAnalytics";
import "./BuilderHelpDialog.css";

const localDateKey = (now) => {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
};

const saveHelpRequest = (accountHolder, email, details, chatId, builderUrl) => {
  const now = new Date();
  return addDoc(collection(firestore, "Feedback", "builder_help", String(now.getFullYear())), {
    createdAt: serverTimestamp(),
    dateKey: localDateKey(now),
    AccountHolder: accountHolder,
    email,
    Details: details,
    chatId: chatId || "",
    builderUrl,
    status: "new",
  });
};

export default function BuilderHelpDialog({ chatId = "", onClose }) {
  const { user } = useAuth();
  const accountHolder = user?.email || user?.displayName || user?.uid || "";
  const [details, setDetails] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (submitting || !details.trim()) return;
    if (!accountHolder) {
      setError("Please sign in again before sending a help request.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await saveHelpRequest(accountHolder, user?.email || "", details.trim(), chatId, window.location.href);
      trackBuilderEvent("builder_chat_help_submitted", { builder_id: window.location.pathname.split("/").filter(Boolean)[1], tab: "chat", chat_id: chatId });
      setSubmitted(true);
    } catch (submissionError) {
      trackBuilderFailure("builder_chat_help_failed", { builder_id: window.location.pathname.split("/").filter(Boolean)[1], tab: "chat", chat_id: chatId, endpoint: "feedback_firestore" }, submissionError);
      console.error("Builder help request failed:", submissionError);
      setError("We couldn't send your request. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return createPortal(
    <div className="agent-helpBackdrop" onMouseDown={() => { if (!submitting) onClose(); }} onKeyDown={(event) => { if (event.key === "Escape" && !submitting) onClose(); }}>
      <div className="agent-helpDialog" role="dialog" aria-modal="true" aria-labelledby="agent-help-title" onMouseDown={(event) => event.stopPropagation()}>
        {submitted ? <><h2 id="agent-help-title">Request sent</h2><p>Your help request has been saved.</p><div className="agent-dialogActions"><button className="mb-btn" type="button" onClick={onClose}>Done</button></div></> :
          <form onSubmit={submit}>
            <h2 id="agent-help-title">Help</h2>
            <p className="agent-helpAccount">Account: {accountHolder || "Signed-in account unavailable"}</p>
            <textarea aria-label="Help request details" value={details} onChange={(event) => setDetails(event.target.value)} rows={5} maxLength={5000} required autoFocus placeholder="Describe where you got stuck or what went wrong…" />
            {error && <p className="agent-helpError" role="alert">{error}</p>}
            <div className="agent-dialogActions"><button className="mb-btn mb-btnSecondary" type="button" disabled={submitting} onClick={onClose}>Cancel</button><button className="mb-btn" type="submit" disabled={submitting || !details.trim()}>{submitting ? "Sending…" : "Send request"}</button></div>
          </form>}
      </div>
    </div>,
    document.body
  );
}
